export default __webpack_public_path__ + "static/media/login-rght.0e3fdf0d.png";